import script from "./chat-client.vue?vue&type=script&lang=ts&setup=true"
export * from "./chat-client.vue?vue&type=script&lang=ts&setup=true"

import "./chat-client.vue?vue&type=style&index=0&id=b88b4130&lang=scss&scoped=true"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b88b4130"]])

export default __exports__